import "./utils/clearTestCollection";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { BrowserRouter } from "react-router-dom";
import AppTheme from "./pages/AppTheme.tsx";
import { CssBaseline } from "@mui/material";

// Fire-and-forget backend warmup so the first /realtime/token call after a
// deploy or idle period doesn't race a cold container. Any failure is silently
// ignored because this is best-effort, not a dependency.
const backendUrl = import.meta.env.VITE_BACKEND_API_URL as string | undefined;
if (backendUrl) {
  fetch(`${backendUrl}/ready`, { method: "GET", cache: "no-store" }).catch(() => {});
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <AppTheme>
        <CssBaseline enableColorScheme />
        <App />
      </AppTheme>
    </BrowserRouter>
  </StrictMode>
);
